import Vue from 'vue';
import moment from 'moment'

const numeral = require('numeral');

// ex: 1000000 = 1,000,000
Vue.filter('numberFormatted', value => {
    if (!value) return ''
    return numeral(value).format('0,0')
});

// ex: 0.755000 = 0.755
Vue.filter('toFixed3', value => {
    if (!value) return ''
    return parseFloat(value).toFixed(3)
});

// ex: 03 Oct 2023
Vue.filter('dateFormatted', stringToFormat => {
    if (!stringToFormat) return ''
    let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
    return moment(dateToFormat).format("D MMM YYYY")
});

// ex: 03-10-2023
Vue.filter('dateFormatted2', stringToFormat => {
    if (!stringToFormat) return ''
    let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
    return moment(dateToFormat).format("DD-MM-YYYY")
});



// WEBPACK FOOTER //
// ./src/components/filters/BrFilter.js